import { createContext } from "react";

export interface ContextType {
	externalId: string;
	updateToken: string;
	restoreToken: string;
	product?: string;
}

const defaultContextValues: ContextType = {
	externalId: "",
	updateToken: "",
	restoreToken: ""
};

export default createContext<ContextType>(defaultContextValues);
